import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=3ddc624e&scoped=true"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=3ddc624e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddc624e",
  null
  
)

export default component.exports